<script setup>
const { is } = defineProps({
  is: {
    type: String,
    default: 'div',
  },
})
const route = useRoute()
const fluid = computed(() => route?.meta?.fluid)
</script>

<template>
  <component
    :is="is"
    :class="fluid ? 'main-container-fluid' : 'main-container'"
  >
    <slot />
  </component>
</template>
